import Link from "next/link";
import { Card, Space } from "antd";
import GroupInfoSmall from "components/groups/GroupInfoSmall";

/**
 * 相关群组卡片组件
 *
 * @param {Array<Object>} groups - 群组列表
 */
const RelatedGroupsCard = ({ groups }: any) => {
  return (
    <Card title="相关群组">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex" }}
      >
        {groups.map((group: any) => (
          <Link
            key={group.id}
            legacyBehavior
            href={`/groups/${group.id}`}
          >
            <a>
              <GroupInfoSmall group={group} />
            </a>
          </Link>
        ))}
      </Space>
    </Card>
  );
};

export default RelatedGroupsCard;
